export {
  type ComponentPrevalenceLookups,
  getComponentPrevalenceLookups,
  getGradedGraphemeClosures,
  type GradedGraphemeClosures,
} from "#component-prevalence";
